import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IBusinessNamesResponse } from '../models/business-names.model';
import { IIndividualsResponse } from '../models/individuals.model';

export const loadBusinessNames = createAction('[BusinessNames] Load BusinessNames');

export const loadBusinessNamesSuccess = createAction(
  '[BusinessNames] Load BusinessNames Success',
  props<{ response: IBusinessNamesResponse[] }>()
);

export const loadBusinessNamesFailure = createAction(
  '[BusinessNames] Load BusinessNames Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);


// * -------------------  // * GET INDIVIDUALS ------------------- * /
export const getIndividualsRequest = createAction(
  '[StaticData] get individuals request'
);

export const getIndividualsResponse = createAction(
  '[StaticData] get individuals response',
  props<{ response: IIndividualsResponse[] }>()
);

export const getIndividualsFailure = createAction(
  '[StaticData] get individuals failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
